import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { useSiteContext } from "../../../contexts/SiteProvider";
import { ASSET_URLS } from "../../../api/AdminUrls";
import { post } from "../../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  asset_type: Yup.string().required("Required"),
  asset_name: Yup.string().required("Required"),
  asset_number: Yup.string().required("Required"),
  asset_details: Yup.string().required("Required"),
  assert_return: Yup.object().required("Required"),
  asset_condition: Yup.object().required("Required"),
});
const AdminAssetsFrom: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);

  //   const onSubmit = (data: any) => {
  //     console.log("Form submitted:", data);
  //   };
  const onSubmit = (data: any) => {
    let url = ASSET_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = ASSET_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "asset_type",
      element: {
        label: "Type",
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "asset_name",
      element: {
        label: "Name",
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "asset_number",
      element: {
        label: "Number.",
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "asset_details",
      element: {
        label: "Details",
        isRequired: true,
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "assert_return",
      element: {
        label: "Return",
        isRequired: true,
        options: [
          { value: "RETURNABLE", label: "RETURNABLE" },
          { value: "NON_RETURNABLE", label: "NON_RETURNABLE" },
        ],
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "asset_condition",
      element: {
        label: "Condition",
        isRequired: true,
        options: [
          { value: "New", label: "New" },
          { value: "Used", label: "Used" },
        ],
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];  
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default AdminAssetsFrom;
